import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_ADD_LOCATION, ROUTE_EDIT_LOCATION, ROUTE_LOCATION} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Location = lazy(() =>
  import('../../../screens/Location')
    .then(module => ({default: module.Location})));

const AddLocation = lazy(() =>
  import('../../../screens/Location')
    .then(module => ({default: module.CreateLocation})));

const UpdateLocation = lazy(() =>
  import('../../../screens/Location')
    .then(module => ({default: module.UpdateLocation})));

const LocationNavigation = [
  {
    path: ROUTE_LOCATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Location />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_LOCATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddLocation />
      </Suspense>
    ),
  },
  {
    path: ROUTE_EDIT_LOCATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <UpdateLocation />
      </Suspense>
    ),
  },
];

export default LocationNavigation;
